import { ReferralLink } from 'data/CustomerPortalTypes';
import { useRef, useState } from 'react';

import GlobirdTable from 'components/Shared/GlobirdTable';
import { formatDisplayDate } from 'utilities/Utility';
import { GlobirdTableContainer } from 'data/GlobirdTableContainer';
import GlobirdPagination, { GlobirdPaginationControl } from 'components/Shared/GlobirdPagination';
import requestDataService from 'services/RequestDataService';
import { selectCurrentAccount, selectUser } from 'store/userSlice';
import { useSelector } from 'react-redux';
import styles from './ReferralLink.module.css';
import { Tag, Tooltip } from 'antd';
import moment from 'moment';
import { CopyOutlined } from '@ant-design/icons';

const ReferralLinks = () => {
	const currentAccount = useSelector(selectCurrentAccount);
	const currentUser = useSelector(selectUser);

	const [referralLinks, setReferralLinks] = useState<ReferralLink[]>([]);
	const globirdPagination = useRef<GlobirdPaginationControl>(null);
	const jumpPage = (referralLinkList: ReferralLink[], totalCount: number) => {
		setReferralLinks(referralLinkList);
	};

	const getStatusTag = (expiryDate: Date) => {
		return moment(expiryDate).isBefore(moment()) ? (
			<Tag color="#ed1c24">Expired</Tag>
		) : (
			<Tag color="#19ac7a">Active</Tag>
		);
	};

	const convertGlobirdTableContainer = (referralLinks: ReferralLink[]): GlobirdTableContainer => {
		let dataContainer = new GlobirdTableContainer();
		dataContainer.headerList.push('Label', 'Url', 'Expiry Date', 'Status');

		for (const referralLink of referralLinks) {
			const { label, url, expiryDate } = referralLink;

			var rowData = [
				label ? <span className={styles['break-long-text']}>{label.toUpperCase()}</span> : 'N/A',
				<>
					<span className={styles['break-long-text']}>{url} </span>
					<Tooltip title="Copied!" trigger="click" placement="right">
						<CopyOutlined
							title="Copy"
							onClick={async () => await navigator.clipboard.writeText(url)}
						/>
					</Tooltip>
				</>,
				formatDisplayDate(expiryDate),
				getStatusTag(expiryDate),
			];
			dataContainer.rowList.push(rowData);
		}

		return dataContainer;
	};

	return (
		<div
			className={styles['referral-link-block']}
			style={{ maxWidth: '1000px', paddingBottom: '35px' }}
		>
			<h3 className={styles['referral-link-heading']}>Previous Links</h3>
			<GlobirdTable dataContainer={convertGlobirdTableContainer(referralLinks)}></GlobirdTable>
			<GlobirdPagination
				ref={globirdPagination}
				requestDataFunc={async (offset, limit) => {
					return await requestDataService.getReferralLinks(
						currentAccount?.accountId,
						currentUser?.emailAddress,
						offset,
						limit
					);
				}}
				onJumpToPage={jumpPage}
			/>
		</div>
	);
};

export default ReferralLinks;
